import { render, staticRenderFns } from "./PatientFiles.vue?vue&type=template&id=d526b188&scoped=true&"
import script from "./PatientFiles.vue?vue&type=script&lang=js&"
export * from "./PatientFiles.vue?vue&type=script&lang=js&"
import style0 from "./PatientFiles.vue?vue&type=style&index=0&id=d526b188&scoped=true&lang=css&"
import style1 from "./PatientFiles.vue?vue&type=style&index=1&id=d526b188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d526b188",
  null
  
)

export default component.exports